import { Option } from 'components/common/types/DropdownItem.types';
import { NetworkItem } from './AddFilter.types';

export const createNetworkItem = (node: Option, networkOptions: Option[]): NetworkItem => {
  const parentOption = networkOptions.find((opt) => opt.code === node.parentCode);
  const parentName = node.parentCode ? parentOption?.name : undefined;

  return {
    code: String(node.code),
    name: node.name,
    parentCode: node.parentCode ? String(node.parentCode) : undefined,
    parentName,
  };
};

export const updateSelectedNetworks = (
  node: Option,
  checked: boolean,
  selectedNetworks: NetworkItem[],
  networkOptions: Option[],
): NetworkItem[] => {
  const networkItem = createNetworkItem(node, networkOptions);

  if (checked) {
    return [...selectedNetworks, networkItem];
  }

  return selectedNetworks.filter((network) => network.code !== networkItem.code);
};
